// extracted by mini-css-extract-plugin
module.exports = {"heading1":"HeadingBlock_heading1__a8vGi","heading2":"HeadingBlock_heading2__Tf5OP","heading3":"HeadingBlock_heading3__U9nkX"};